//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import orderCreatable from "~/mixins/orderCreateable.js";

export default {
  mixins: [orderCreatable],

  props: {
    content: {
      required: true,
    },
    createLink: {
      required: false,
      type: String,
    },
  },
  methods: {
    isOdd(number) {
      return number % 2 !== 0;
    },
  },
};
